/**
 * @file 提取积分 hook
 */
import {useMutation} from '@tanstack/react-query';
import {invalidatePointsSummary} from './usePersonalPoints';
import {invalidateProjectSummary} from './useProjectSummary';
import {resetProjectTransactions} from './useProjectTransactions';
import message from '@/components/common/Message';
import type {RedeemPointsParams} from '@/services/points/interface';
import {redeemProjectPoints} from '@/services/points';
import {invalidateProjectInfo} from '@/hooks/useProject';

export const useRedeemPoints = () =>
    useMutation({
        mutationFn: (params: RedeemPointsParams) => redeemProjectPoints(params),
        onSuccess: (_data, variables) => {
            message.success('积分提取成功');
            void invalidatePointsSummary();
            void invalidateProjectSummary();
            void resetProjectTransactions(variables.projectId);
            void invalidateProjectInfo(variables.projectId);
        },
    });
